import { Injectable } from "@angular/core";
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
} from "@angular/common/http";

import { CognitoService } from "./cognito/cognito.service";

import { Observable } from "rxjs";

@Injectable()
export class AddAuthToRequestsInterceptor implements HttpInterceptor {
  constructor(private cognitoService: CognitoService) { }
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (this.cognitoService.isAuthenticated) {
      const idToken = this.cognitoService.idToken;
      if (idToken) {
        const cloned = req.clone({
          headers: req.headers
          //.set("Authorization", idToken)
          //.set("Content-Type", "application/json")
          //.set("Access-Control-Allow-Origin", "*"),
        });

        return next.handle(cloned);
      }
    } else {
      return next.handle(req);
    }
  }
}
